export default __webpack_public_path__ + "static/media/132100066_236884421123068_7716908094536328432_n.d91fbc63.jpg";